import { render, staticRenderFns } from "./CreationPeriods.vue?vue&type=template&id=7cf1df0f&lang=true"
import script from "./CreationPeriods.vue?vue&type=script&lang=js"
export * from "./CreationPeriods.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports